"use strict";
exports.__esModule = true;
var utils_1 = require("./utils");
exports["default"] = {
    please_select_time: function () { return "Select Time"; },
    start_time: function () { return "Start Time"; },
    end_time: function () { return "End Time"; },
    hour: function () { return "Hour"; },
    minute: function () { return "Min"; },
    second: function () { return "Sec"; },
    duration: {
        hour: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " hr"; },
        minute: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " min"; },
        second: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return " " + d.amount + " sec"; }
    },
    dayNamesMin: {
        Su: function () { return "SUN"; },
        Mo: function () { return "MON"; },
        Tu: function () { return "TUE"; },
        We: function () { return "WED"; },
        Th: function () { return "THU"; },
        Fr: function () { return "FRI"; },
        Sa: function () { return "SAT"; }
    },
    weekNamesMin: {
        Su: function () { return "SUN"; },
        Mo: function () { return "MON"; },
        Tu: function () { return "TUE"; },
        We: function () { return "WED"; },
        Th: function () { return "THUR"; },
        Fr: function () { return "FRI"; },
        Sa: function () { return "SAT"; }
    },
    monthNamesShort: {
        Jan: function () { return "JAN"; },
        Feb: function () { return "FEB"; },
        Mar: function () { return "MAR"; },
        Apr: function () { return "APR"; },
        May: function () { return "MAY"; },
        Jun: function () { return "JUN"; },
        Jul: function () { return "JUL"; },
        Aug: function () { return "AUG"; },
        Sep: function () { return "SEP"; },
        Oct: function () { return "OCT"; },
        Nov: function () { return "NOV"; },
        Dec: function () { return "DEC"; }
    },
    ok: function () { return "OK"; },
    now: function () { return "Now"; },
    today: function () { return "Today"; },
    day: function () { return "Day"; },
    weekHeader: function () { return "Week"; },
    month: function () { return "Mon"; },
    year: function () { return "Year"; },
    schedule: function () { return "Schedule"; },
    allDay: function () { return "All Day"; },
    monthNames: {
        January: function () { return "JAN"; },
        February: function () { return "FEB"; },
        March: function () { return "MAR"; },
        April: function () { return "APR"; },
        May: function () { return "MAY"; },
        June: function () { return "JUN"; },
        July: function () { return "JUL"; },
        August: function () { return "AUG"; },
        September: function () { return "SEP"; },
        October: function () { return "OCT"; },
        November: function () { return "NOV"; },
        December: function () { return "DEC"; }
    },
    startsWith: function () { return "Start"; },
    endsWith: function () { return "End"; },
    edit: function () { return "Edit"; },
    confirm: function () { return "Confirm"; },
    cancel: function () { return "Cancel"; },
    collapse_sidebar: function () { return "Collapse Sidebar"; },
    expand_sidebar: function () { return "Expand Sidebar"; },
    expand: function () { return "More"; },
    collapse: function () { return "Less"; },
    no_data: function () { return "No data available"; },
    all_results_total: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " items in total"; },
    per_page_item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " items per page"; },
    item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " items"; },
    go_to_page: function (_d) { var d = (0, utils_1.reqArgs)(["number"], _d); return "Go to Page " + d.number; },
    select_all: function () { return "Select All"; },
    clear: function () { return "Clear"; },
    reset: function () { return "Reset"; },
    please_enter: function () { return "Please enter"; },
    input_placeholder: function (_d) { var d = (0, utils_1.reqArgs)(["context"], _d); return "Please enter " + d.context; },
    phone_invalid: function () { return "Invalid mobile number"; },
    phone: function () { return "Mobile Number"; },
    please_select: function () { return "Please select"; },
    upload_file: function () { return "Upload File"; },
    upload_again: function () { return "Upload Again"; },
    uploading: function () { return "Uploading ..."; },
    upload_successful: function () { return "Uploaded"; },
    upload_failed: function () { return "Failed to upload file"; },
    click_upload: function () { return "Click to upload"; },
    drag_upload: function () { return "Drag and drop file here to upload"; },
    more_filters: function () { return "More Labels"; },
    empty: function () { return "Clear"; },
    more: function () { return "More"; },
    more_labels: function () { return "More Filters"; },
    selected_items: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " items selected"; },
    password_placeholder: function () { return "Please enter password"; },
    preStep: function () { return "Prev"; },
    nextStep: function () { return "Next"; },
    formMessage: function (_d) { var d = (0, utils_1.reqArgs)(["content"], _d); return d.content + " errors"; },
    upload_manager: {
        title: {
            in_progress: function () { return "Uploading ..."; },
            task_cancal: function () { return "Task canceled"; },
            single: {
                succeeded: function () { return "Uploaded"; },
                failed: function () { return "Failed to upload file"; }
            },
            multiple: {
                all_succeeded: function () { return "All files successfully uploaded"; },
                all_failed: function () { return "All files upload failed"; },
                partial_fail: function () { return "Some files upload failed"; },
                succeed: function () { return "Uploaded"; },
                failed: function () { return "Failed to upload file"; }
            }
        },
        actions: {
            cancel: function () { return "Cancel Upload"; },
            cancel_all: function () { return "Cancel All"; },
            retry: function () { return "Upload Again"; },
            error_and_retry: function () { return "Network error. Please upload again."; },
            retry_all: function () { return "Retry All"; }
        },
        messages: {
            cancelled: function () { return "Upload canceled"; },
            estimated_upload_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "Estimated upload time " + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "Uploading " + d.count + " files ..."; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " files upload failed"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " files uploaded"; },
            has_identical_files: function () { return "Files with identical content detected in the directory"; }
        }
    },
    download_manager: {
        title: {
            in_progress: function () { return "Downloading ..."; },
            task_cancal: function () { return "Task canceled"; },
            single: {
                succeeded: function () { return "Downloaded"; },
                failed: function () { return "Failed to download file"; }
            },
            multiple: {
                all_succeeded: function () { return "All files successfully downloaded"; },
                all_failed: function () { return "All files download failed"; },
                partial_fail: function () { return "Some files download failed"; },
                succeed: function () { return "Downloaded"; },
                failed: function () { return "Failed to download file"; }
            }
        },
        actions: {
            cancel: function () { return "Cancel Download"; },
            cancel_all: function () { return "Cancel All"; },
            retry: function () { return "Download Again"; },
            error_and_retry: function () { return "Network error. Please download again."; },
            retry_all: function () { return "Retry All"; }
        },
        messages: {
            pending: function () { return "Pending..."; },
            cancelled: function () { return "Download canceled"; },
            estimated_download_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "Estimated download time " + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "Downloading " + d.count + " files ..."; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " files download failed"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " files downloaded"; },
            has_identical_files: function () { return "Files with identical content detected in the directory"; }
        }
    },
    emptyMessage: function () { return "No options"; },
    emptyMatchedMessage: function () { return "No matching data"; },
    emptyFilterMessage: function () { return "0 search results"; },
    pleaseEnterSearchContent: function () { return "Enter query content"; },
    region: {
        China: function () { return "China"; },
        HongKong: function () { return "Hong Kong"; },
        Macao: function () { return "Macao"; },
        Taiwan: function () { return "Taiwan"; },
        America: function () { return "U.S.A."; },
        Australia: function () { return "Australia"; },
        Singapore: function () { return "Singapore"; }
    }
};
